import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useClientIsMobile } from '@/composables/useClient'

// Anchors a fixed popup in the upper-right corner and hides it on mobile screens
export function usePopupPosition(initialTop = 54, initialRight = 24) {
  const top = ref(`${initialTop}px`)
  const right = ref(`${initialRight}px`)

  const isMobile = useClientIsMobile()
  const isHidden = computed(() => isMobile.value)

  const recalc = () => {
    if (isHidden.value) return
    top.value = `${initialTop}px`
    right.value = `${initialRight}px`
  }

  onMounted(() => {
    recalc()
    window.addEventListener('resize', recalc)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', recalc)
  })

  return { top, right, isHidden }
} 